import { combineReducers } from 'redux';

import { CuratedAd } from "./curated-ad/c-ad.reducer";
import { Contextual } from "./contextual/contextual-media.reducer";
import { AddOn } from "./addon/addon.reducer";

export const audiences = combineReducers({
    
    CuratedAd,
    Contextual,
    AddOn

});
